import { Injectable, Injector } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ModalConfirmationComponent } from '../components/modal-confirmation/modal-confirmation.component';
import { ModalErrorComponent }        from '../components/modal-error/modal-error.component';

@Injectable({
    providedIn: 'root'
})
export class ModalService {

    private modalService: NgbModal;
    
    constructor(private injector: Injector, public activeModal: NgbActiveModal) { }

    private openModal() {

        this.modalService = this.injector.get(NgbModal);

    }

    public closeModal(result?: any) {

		this.modalService.dismissAll(result);

	}

    public showErrorModal(message: string) {

		this.modalService = this.injector.get(NgbModal);

		const modalOptions: any = {
			size: 'md',
			centered: true,
			keyboard: false,
			backdrop: 'static'
		};

		const modalRef = this.modalService.open(
			ModalErrorComponent,
			modalOptions
		);

		modalRef.componentInstance.message = message;

	}

    public showConfirmationModal(...message: string[]) {

		this.modalService = this.injector.get(NgbModal);

		const modalOptions: any = {
			size: 'md',
			centered: true,
			keyboard: false,
			backdrop: 'static'
		};

		const modalRef = this.modalService.open(
			ModalConfirmationComponent,
			modalOptions
		);

		modalRef.componentInstance.message = message;

	}

}
